<ion-header *ngIf="modal"
            class="ion-no-shadow ion-no-border">
    <ion-toolbar>
        <ng-container>
            <ion-title>{{ 'COMMUNITY_FILTER_MODAL_HEADER' | translate }}</ion-title>
            <ion-buttons slot="end">
                <ion-button (click)="backClicked()">
                    <ion-icon slot="icon-only"
                              color="dark"
                              name="close"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ng-container>
    </ion-toolbar>
</ion-header>

<div class="ion-padding"
     [ngClass]="{'scroll-box': modal}">
    <div class="filter-card"
         *ngIf="!loading">

        <div class="filter-box">

            <ion-row>
                <ion-col size="12"
                         class="ion-no-padding">
                    <form (ngSubmit)="seeResults()"
                          #f="ngForm"
                          novalidate>
                        <ion-item>
                            <ion-label *ngIf="plt.sizeMd"
                                       position="stacked">
                                {{ 'ATTENDEE_LIST_SEARCH_LABEL' | translate }}:
                            </ion-label>
                            <ion-label *ngIf="!plt.sizeMd"
                                       position="fixed">
                                {{ 'ATTENDEE_LIST_SEARCH_LABEL' | translate }}:
                            </ion-label>
                            <ion-searchbar [(ngModel)]="attendeesSearch"
                                           name="attendee-search"
                                           [ngClass]="{'full': !modal}"
                                           inputmode="search"
                                           (keyup.enter)="seeResults()"
                                           [placeholder]=" 'ATTENDEE_LIST_SEARCH_PLACEHOLDER' | translate">
                            </ion-searchbar>
                        </ion-item>
                    </form>
                </ion-col>
            </ion-row>

            <ion-row *ngIf="event.zip_code_search && event.counties.length"
                     class="county-box ion-no-padding">
                <ion-col size="12"
                         class="ion-no-padding">

                    <ion-item>
                        <ion-label *ngIf="plt.sizeMd"
                                   position="stacked">
                            {{ 'ATTENDEE_LIST_SEARCH_COUNTY_LABEL' | translate }}:
                        </ion-label>
                        <ion-label *ngIf="!plt.sizeMd"
                                   position="fixed">
                            {{ 'ATTENDEE_LIST_SEARCH_COUNTY_LABEL' | translate }}:
                        </ion-label>

                        <ion-select name="select-county"
                                    [interface]="selectType"
                                    [interfaceOptions]="{cssClass:'not-overflow'}"
                                    (click)="showCountyFilter($event)"
                                    [placeholder]="(selectedCounties.length ? selectedCounties.join() : 'PLACEHOLDER_PLEASE_SELECT' | translate)">
                        </ion-select>
                    </ion-item>
                </ion-col>
            </ion-row>

            <ion-row *ngIf="enableDistance"
                     class="county-box ion-no-padding">
                <ion-col size="10"
                         class="ion-no-padding">

                    <ion-item class="item-address-search">
                        <ion-label *ngIf="plt.sizeMd"
                                   position="stacked">
                            {{ 'ATTENDEE_LIST_SEARCH_ADDRESS_LABEL' | translate }}:
                        </ion-label>
                        <ion-label *ngIf="!plt.sizeMd"
                                   position="fixed">
                            {{ 'ATTENDEE_LIST_SEARCH_ADDRESS_LABEL' | translate }}:
                        </ion-label>

                        <ng-template #emptyTemplate
                                     let-attrs="attrs"
                                     class="ion-text-center">
                            {{ 'ATTENDEE_LIST_SEARCH_ADDRESS_NO_ITEMS' | translate }}
                        </ng-template>
                        <ng-template #addressTemplate
                                     let-attrs="attrs">
                            {{attrs.data.address}}
                        </ng-template>

                        <ion-auto-complete #autocomplete
                                           [maxResults]="6"
                                           [dataProvider]="geocodeService"
                                           [dataProviderAttribute]="'addresses'"
                                           [template]="addressTemplate"
                                           [selectionTemplate]="addressTemplate"
                                           [emptyTemplate]="emptyTemplate"
                                           [options]="{mode: 'ios', placeholder: 'ATTENDEE_LIST_SEARCH_ADDRESS_PLACEHOLDER' | translate }"
                                           (ionAutoInput)="autocompleteFocus()"
                                           (itemsShown)="autocompleteFocus()"
                                           (itemsHidden)="autocompleteBlur()"
                                           (autoBlur)="autocompleteBlur()"
                                           (itemSelected)="setAddress($event)"
                                           [model]="selectedAddress"
                                           (itemsCleared)="selectedAddress = null">
                        </ion-auto-complete>

                    </ion-item>
                </ion-col>

                <ion-col size="12"
                         size-sm="2"
                         class="ion-no-padding">

                    <ion-item class="item-address-search-distance">
                        <ion-select id="select-distance"
                                    name="select-distance"
                                    [interface]="selectType"
                                    [interfaceOptions]="{cssClass:'width-100.not-overflow'}"
                                    #distance="ngModel"
                                    [(ngModel)]="selectedDistance">
                            <ion-select-option [value]="5">5km</ion-select-option>
                            <ion-select-option [value]="10">10km</ion-select-option>
                            <ion-select-option [value]="15">15km</ion-select-option>
                            <ion-select-option [value]="20">20km</ion-select-option>
                            <ion-select-option [value]="30">30km</ion-select-option>
                            <ion-select-option [value]="50">50km</ion-select-option>
                        </ion-select>
                    </ion-item>
                </ion-col>
            </ion-row>

            <ion-row class="ion-no-padding">
                <ion-col class="ion-no-padding">
                    <ng-container *ngIf="event.matching_status && user">
                        <hr class="full" />

                        <div class="keyword-scroll">
                            <ng-container *ngFor="let container of event.containers; let c = index">

                                <ng-container *ngIf="visibleAllKeywords || plt.sizeSm || c < keywordContainerLimits">
                                    <hr class="full"
                                        *ngIf="c > 0">
                                    <h4><strong>{{c+1}}.</strong> {{ container.translate(userLang, event.default_locale).name }}</h4>
                                    <ion-row class="keyword-box ion-no-padding">

                                        <ng-container *ngFor="let column of (container.columns === 2 ? [1,2] : [1])">
                                            <ion-col class="multi-columns ion-no-padding"
                                                     size="{{ container.columns === 2 ? '6' : '12' }}">
                                                <br *ngIf="plt.sizeSm && column == 2">
                                                <h5 *ngIf="container.columns === 2">{{ container.translate(userLang, event.default_locale)['column_' + column + '_name'] }}</h5>

                                                <!-- Keywords -->
                                                <div class="keyword-list">
                                                    <ng-container *ngFor="let keyword of container.keywords">
                                                        <ng-container *ngIf="keyword.isValid(event.available_locales, user.selected_participant_id)">
                                                            <ion-chip *ngIf="keyword.approved_at || !keyword.participant_id"
                                                                      [ngClass]="{'enabled': isSelected(column, keyword)}"
                                                                      (click)="toggleKeyword(column, keyword)">
                                                                <ion-label>
                                                                    {{ keyword.translate(userLang, event.default_locale).name | cut: 80 }}
                                                                    <ion-spinner *ngIf="keyword.loading == column"
                                                                                 name="dots"></ion-spinner>
                                                                </ion-label>
                                                            </ion-chip>
                                                        </ng-container>
                                                    </ng-container>
                                                </div>

                                            </ion-col>
                                        </ng-container>
                                    </ion-row>
                                </ng-container>

                            </ng-container>
                        </div>

                        <ng-container *ngIf="event.containers.length > keywordContainerLimits && !plt.sizeSm">
                            <ng-container *ngIf="!visibleAllKeywords">
                                <a (click)="visibleAllKeywords=true"
                                   class="more">
                                    {{ 'DASHBOARD_MATCHING_LIST_MORE' | translate:{count:event.containers.length - keywordContainerLimits} }}
                                    <svg-icon [applyClass]="true"
                                              src="/assets/icons/ico-arrow.svg"
                                              class="collapsible ">
                                    </svg-icon>
                                </a>
                            </ng-container>
                            <ng-container *ngIf="visibleAllKeywords">
                                <a (click)="visibleAllKeywords=false"
                                   class="more">
                                    {{ 'DASHBOARD_MATCHING_LIST_LESS' | translate:{count:event.containers.length - keywordContainerLimits} }}
                                    <svg-icon [applyClass]="true"
                                              src="/assets/icons/ico-arrow.svg"
                                              class="collapsible opened">
                                    </svg-icon>
                                </a>
                            </ng-container>
                        </ng-container>

                    </ng-container>

                    <ion-row *ngIf="!modal"
                             class="ion-no-padding">
                        <ion-col class="ion-no-padding ion-text-left">
                            <ion-button *ngIf="plt.sizeSm && (attendeesSearch || selectedKeywordIds.length > 0)"
                                        (click)="resetResults()">
                                {{ 'ATTENDEE_LIST_BTN_CLEAR_SEARCH' | translate }}
                            </ion-button>
                        </ion-col>
                        <ion-col class="ion-no-padding ion-text-right">
                            <ion-button (click)="seeResults()"
                                        [disabled]="!modal && (!attendeesSearch || attendeesSearch.length < fulltextMinSearchLenght) && selectedKeywordIds.length == 0">
                                {{ 'BUTTON_SEE_RESULTS' | translate }}
                            </ion-button>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>


        </div>
    </div>
</div>

<ion-footer *ngIf="modal">
    <ion-row class="action-buttons ion-no-padding">
        <ion-col class="ion-no-padding ion-text-right">
            <ion-button (click)="seeResults()">
                {{ 'BUTTON_SEE_RESULTS' | translate }}
            </ion-button>
        </ion-col>
    </ion-row>
</ion-footer>

<ng-container *ngIf="loading">
    <div class="content-centered-column">
        <div class="content-centered-row">
            <ion-spinner></ion-spinner>
        </div>
    </div>
</ng-container>